const translations = {
    intervalOutOfRangeError: 'Service intervals must be between {{min}} and {{max}}.',
    intervalRequiredError: 'Enter a service interval for every part.'
};

export default translations;
